// 集合

import mainStore from "./mainModule";
import dataStore from "./dataProcessModule";

export default {
  mainStore,
  dataStore,
};
